import { Navbar } from "../Navbar/Navbar";
import { Footer } from "../Footer/Footer";
import React, { useEffect, useState } from "react";
import { Provider } from "../../_helpers/Contexts/mainContext";

const Layout = ({ children }) => {
  const [theme, setTheme] = useState("default");
  const [sizeTheme, setSizeTheme] = useState(100);

  useEffect(() => {
    document.documentElement.className = theme;
  }, [theme]);
  useEffect(() => {
    document.body.style.zoom = sizeTheme + "%";
  }, [sizeTheme]);

  return (
    <Provider value={{ theme, setTheme, sizeTheme, setSizeTheme }}>
      <Navbar />
      <div className="main container-fluid">{children}</div>
      <Footer />
    </Provider>
  );
};

export { Layout };
